import React, { Component } from "react";
import { profile, branch, alert, total, float, toFixed, format_date, random_charactor, GET, POST, PUT, DELETE, loading, Status, params, required, DatePicker, Select, BtnIcon, Swal, Pagination, Switch, Navbar, Modal, Resizer } from "../../../components/CustomComponent.js";
export default class Setting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      search: "",

      data: []
      ,
      count: 0,

      id: "",
      uid: "",
      name: "",
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    loading(true);
    let result = await GET("admin/manage/activity-type-lands/list", { page: page, data_search: this.state.search });
    if (result?.status) {
      this.setState({ data: result.data, count: result.count });
    }
    loading(false);
  };
  CreateUpdate = async () => {
    if (!this.state.name.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อ");
      return;
    }

    loading(true);
    let body = {
            name: this.state.name,
    };
     let result = !this.state.uid ? await POST("admin/manage/activity-type-lands/create", body) : await PUT("admin/manage/activity-type-lands/update/" + this.state.uid, body);
    if (result?.status) {
      alert("#", "success");
   }else{
alert("","warning","แจ้งเตือน","เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง")
}
    loading(false);
  };
  Delete = async (id) => {
    if (await alert("", "warning", "ลบข้อมูล", "ยืนยันการลบรายการนี้หรือไม่ ?", "ลบข้อมูล", "ยกเลิก")) {
      loading(true);
       let result = await DELETE("admin/manage/activity-type-lands/delete/" + id, null);
      if (result?.status) {
        alert("#", "success");
      }
alert("#", "success");
      loading(false);
    }
  };
  render() {
    const { modal_create, modal_update, search, data, count, id, uid, name } = this.state;
    return (
      <div className="w-100 min-vh-100 bg-light">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex flex-wrap">
              <h4 className="fw-bold mb-3 me-3">ประเภทกิจกรรมที่ดิน</h4>
              <input
                type="text"
                className="form-control wpx-250 me-2 mb-2"
                placeholder="ค้นหา..."
                onChange={(e) => {
                  this.setState({ search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={search}
              />
              <div className="d-flex">
                <button
                  className="btn btn-primary px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-primary px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>
              <button
                className="btn btn-primary px-3 ms-auto mb-2"
                onClick={async () => {
                  this.setState({ id: "", uid: "", name: "", modal_create: true });
                }}
              >
                + เพิ่มข้อมูล
              </button>
            </div>
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="wpx-150">รหัส</td>
                    <td>ชื่อ</td>
                    <td className="wpx-110"></td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr>
                      <td>{`ATL${String(item.id).padStart(5, '0')}` || "-"}</td>
                      <td>{item.name || "-"}</td>
                      <td className="text-center align-middle">
                        <div className="d-flex">
                          <BtnIcon
                            type="update"
                            onClick={() => {
                              this.setState({ ...item, modal_update: true });
                            }}
                          />
                          <BtnIcon
                            type="delete"
                            onClick={() => {
                              this.Delete(item?.uid);
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-between flex-wrap mt-2">
            <span className="mb-3">รายการทั้งหมด {count || 0} รายการ</span>
            <Pagination className="mb-3" count={Math.ceil(count / 10) || 1} showFirstButton showLastButton onChange={(_, page) => this.Get(page)} />
          </div>
        </div>
        {/* CREATE UPDATE */}
        <Modal show={modal_create || modal_update} onHide={() => this.setState({ modal_create: false, modal_update: false })}>
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">{modal_create ? "เพิ่มข้อมูล" : modal_update ? "แก้ไขข้อมูล" : ""}</h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="d-flex mb-3">
              <div className="wpx-120 mt-2">ชื่อ</div>
              <input
                type="text"
                className="form-control"
                placeholder="กรอกข้อมูล..."
                onChange={(e) => {
                  this.setState({ name: e.target.value });
                }}
                value={name}
              />
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <button
              className="btn btn-primary px-5 me-1"
              onClick={() => {
                this.CreateUpdate();
              }}
            >
              บันทึก
            </button>
            <button
              className="btn btn-outline-primary px-5 ms-1"
              onClick={() => {
                this.setState({ modal_create: false, modal_update: false });
              }}
            >
              ยกเลิก
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
